/**
 * Comma-separated preference lists parsed in login; trims and drops empty entries.
 */
export function normalizeRsiClubChatIdList(
  list: string[] | null | undefined,
): string[] {
  if (!list?.length) {
    return [];
  }
  return list.map((id) => String(id).trim()).filter((id) => id.length > 0);
}

export function isRsiClubChatActiveForMember(params: {
  featureEnabled: boolean;
  memberOrgId?: string | number | null;
  memberSiteId?: string | number | null;
  includeOrgIds?: string[] | null;
  includeSiteIds?: string[] | null;
  excludeOrgIds?: string[] | null;
  excludeSiteIds?: string[] | null;
}): boolean {
  const { featureEnabled, memberOrgId, memberSiteId, includeOrgIds, includeSiteIds, excludeOrgIds, excludeSiteIds } =
    params;

  if (!featureEnabled) {
    return false;
  }

  const iOrg = normalizeRsiClubChatIdList(includeOrgIds);
  const iSite = normalizeRsiClubChatIdList(includeSiteIds);
  const xOrg = normalizeRsiClubChatIdList(excludeOrgIds);
  const xSite = normalizeRsiClubChatIdList(excludeSiteIds);

  const hasIncludeData = iOrg.length > 0 || iSite.length > 0;
  const hasExcludeData = xOrg.length > 0 || xSite.length > 0;

  const orgStr = memberOrgId != null && memberOrgId !== '' ? String(memberOrgId).trim() : '';
  const siteStr = memberSiteId != null && memberSiteId !== '' ? String(memberSiteId).trim() : '';

  const inInclude = (orgStr.length > 0 && iOrg.includes(orgStr)) || (siteStr.length > 0 && iSite.includes(siteStr));
  const inExclude = (orgStr.length > 0 && xOrg.includes(orgStr)) || (siteStr.length > 0 && xSite.includes(siteStr));

  if (!hasIncludeData && !hasExcludeData) {
    return true;
  }

  if (hasIncludeData && hasExcludeData) {
    if (inExclude) {
      return false;
    }
    if (inInclude) {
      return true;
    }
    return false;
  }

  if (hasIncludeData && !hasExcludeData) {
    return inInclude;
  }

  if (!hasIncludeData && hasExcludeData) {
    if (inExclude) {
      return false;
    }
    return true;
  }

  return false;
}
